import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }

      try {
        const response = await axios.get(
          `${BACKEND_URL}/api/auth/google?session_id=${sessionId}`,
          { withCredentials: true }
        );

        // Update auth context immediately
        await fetchUser();

        // Navigate to home page
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Auth callback failed:', error);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [location, navigate, fetchUser]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Authenticating...</p>
      </div>
    </div>
  );
}